/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Cобытие
 */
export interface Event {
  /**
   * Идентификатор типа события
   * @format uuid
   */
  id?: string;

  /** Признак активного события */
  isActive?: boolean;
}

/**
 * Сообщение
 */
export interface Message {
  /**
   * Идентификатор сообщения
   * @format uuid
   */
  id?: string;

  /** Признак архивного сообщения */
  isArchive?: boolean;

  /** Признак активного сообщения */
  isActive?: boolean;
}

/**
 * Подписки
 */
export interface Subscribe {
  events?: Event[];
  messages?: Message[];
}

/**
 * Статус ответа
 */
export interface Result {
  status?: string;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Тип событий
 */
export interface EventResponse {
  /**
   * Идентификатор страны
   * @format uuid
   */
  id?: string;

  /** Область применения события */
  type?: string;

  /** МС-владелец события */
  owner?: string;

  /** Наименование события */
  name?: string;

  /** Наименование события */
  caption?: string;

  /** Шаблон сообщения события */
  message?: string;

  /**
   * Количество дней показа сообщения до даты события
   * @format int32
   */
  viewDaysBefore?: number;

  /**
   * Порядковый день месяца, исполнения периодического события
   * @format int32
   */
  periodEventDay?: number;

  /**
   * Количество дней показа сообщения после даты события
   * @format int32
   */
  viewDaysAfter?: number;

  /** изнак того, какие дни учитывать для расчёта дат отображения события */
  onlyWorkDays?: boolean;

  /** Признак активного события */
  isActive?: boolean;

  /**
   * Дата начала показа события в текущем периоде
   * @format date
   */
  periodStartDate?: string;

  /**
   * Дата периодического события
   * @format date
   */
  periodDeadline?: string;

  /**
   * Дата завершения показа события в текущем периоде
   * @format date
   */
  periodStopDate?: string;

  /**
   * Порядок сортировки
   * @format int32
   */
  sortOrder?: number;
}

/**
 * Ответ со списком сообщений
 */
export interface ClientMessagesResponse {
  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Количество страниц в выборке
   * @format int32
   */
  totalPagesCount?: number;

  /**
   * Количество всех записей в выборке
   * @format int32
   */
  totalRowsCount?: number;

  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** Список событий */
  events?: CustomEvent[];
}

/**
 * Событие
 */
export interface CustomEvent {
  /** Область применения типа события */
  type?: string;

  /** Идентификатор типа события */
  eventId?: string;

  /** Заголовок сообщения */
  title?: string;

  /** Текст сообщения */
  message?: string;

  /** Параметры для вставки в текст сообщения */
  additionalValues?: Record<string, string>;

  /** Идентификатор сообщения по событию */
  id?: string;

  /** Тип валютного документа */
  docTypeName?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  docId?: string;

  /**
   * Дата события
   * @format date
   */
  eventDate?: string;

  /** Признак скрытого сообщения */
  isArchive?: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-events
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://127.0.0.1:8080
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Подписки
     * @name Subscribe
     * @summary Подписка на события и сообщения
     * @request POST:/api/events/v1/external/subscribe
     * @secure
     */
    subscribe: (data: Subscribe, params: RequestParams = {}) =>
      this.request<Result, Result | GenericError>({
        path: `/api/events/v1/external/subscribe`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из справочников
     * @name RecalculateDatesEvents
     * @summary Пересчет дат для событий
     * @request POST:/api/events/v1/external/dict/event/recalculate
     * @secure
     */
    recalculateDatesEvents: (params: RequestParams = {}) =>
      this.request<EventResponse[], GenericError>({
        path: `/api/events/v1/external/dict/event/recalculate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения клиента
     * @name GetRequestInformList
     * @summary Получение списка сообщений клиента
     * @request GET:/api/events/v1/external/messages
     * @secure
     */
    getRequestInformList: (
      query?: {
        page?: number;
        size?: number;
        eventType?: string;
        eventId?: string;
        documentId?: string;
        isArchive?: boolean;
        beginDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ClientMessagesResponse, object | GenericError>({
        path: `/api/events/v1/external/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение данных из справочников
     * @name GetEvents
     * @summary Получение справочника "Типы событий"
     * @request GET:/api/events/v1/external/dict/event
     * @secure
     */
    getEvents: (
      query?: { type?: string; isActive?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<EventResponse[], GenericError>({
        path: `/api/events/v1/external/dict/event`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
